import { Person } from '@/quote/domain/Person';
import { Quote } from '@/quote/domain/Quote';

export class QuoteInterface extends Quote {

  public applicants: Array<Person>;
  public primary: Person;
  public spouse: Person | null;
  public children: Array<Person>;
  public dependants: Array<Person>;

  public constructor ({ applicants, primary, spouse, children, dependants }: { applicants: Array<Person>, type: string, primary: Person, spouse: Person | null, children: Array<Person>, dependants: Array<Person> }) {
    super({ type: '', zip_code: 0, applicants, county: '', effective_date: 0 });
    this.applicants = applicants;
    this.primary = primary;
    this.spouse = spouse;
    this.children = children;
    this.dependants = dependants;
  }

}
